"use client";

import Script from "next/script";

export default function CalendlyLink({ bgColor }) {
  const openCalendly = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: "https://calendly.com/seternitysolutions/30min",
      });
    }
  };

  return (
    <>
      {/* Calendly CSS */}
      <link
        href="https://assets.calendly.com/assets/external/widget.css"
        rel="stylesheet"
      />

      {/* Your button / link */}
      <button
        onClick={openCalendly}
        className={`cursor-pointer font-semibold ${bgColor ? "bg-white text-black w-full py-3" : "bg-brand text-white py-5"} px-6 rounded-lg`}
      >
        Book a Strategy Call
      </button>

      {/* Calendly Script */}
      <Script
        src="https://assets.calendly.com/assets/external/widget.js"
        strategy="lazyOnload"
      />
    </>
  );
}